import React from 'react'
import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'
import { getText } from '../../../../../internal/TextLabels'

import styles from './order.style'

const OrderSummary = ({ totalAmount }) => (
  <div style={styles.table} className={`${midas.columns}`}>
    <div className={`${midas.column} ${midas.col9}`} />
    <div
      style={styles.tableAmountCell}
      className={`${midas.column} ${midas.col3}`}
    >
      <span style={styles.textStrong}>
        {getText('payApply.order.total')}
        :&nbsp;
        {totalAmount
          ? getText(
              'default.currency',
              Number(totalAmount).toLocaleString('sv-SE', {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }),
            )
          : ''}
      </span>
    </div>
  </div>
)

OrderSummary.propTypes = {
  totalAmount: PropTypes.number.isRequired,
}

export default OrderSummary
